import sections from './Sections/index';

/**
 * Страница «Отделка квартир».
 */
function main(): void
{
	sections();
}

/**
 * Module.
 */
export {
	main as default,
};



// WEBPACK FOOTER //
// ./app/Routes/Decoration/index.ts